export default __webpack_public_path__ + "static/27-727fc8f5ea36e3ae1ec03ef1af713944.webp";